// Nombre y foto del autor de un comentario.
//
// POR QUE HACE FALTA: los listados de comentarios del backend identifican al autor
// de forma pobre. Medido contra pre el 2026-09-09 en el de eventos
// (`POST /api/obtener-comentarios/eventos`), por cada comentario devuelve:
//
//   { idUsuario: "15e4c1f7-...", autor: "@YayoGH",
//     fotoPerfil: null, fotoPerfilUrl: null }
//
// O sea: la foto viene SIEMPRE vacia y `autor` trae el NICKNAME, no el nombre.
// Pintado tal cual, cada comentario salia con la silueta gris y un arroba en lugar
// de la persona. Lo unico aprovechable es `idUsuario`, y con el se puede resolver
// el perfil —es lo que ya hace el feed en `useCommentData`, con `getUserInfoService`,
// que ademas cachea y deduplica peticiones.
//
// Estas funciones son solo la DECISION de que mostrar; quien trae los perfiles es
// la seccion. Se separan para poder probar la decision sin red.

import {
  DEFAULT_PROFILE_IMAGE,
  getProfileImageFromUser,
} from "../../../infrastructure/utils/normalizeImageSrc";

const texto = (valor) => (valor ?? "").toString().trim();

// Nombre para mostrar a partir de un perfil. Mismo criterio que el feed: nombre y
// apellidos si los hay, y si no lo que exista.
export const nombreDePerfil = (perfil = {}) =>
  texto(`${texto(perfil.nombres)} ${texto(perfil.apellidos)}`) ||
  texto(perfil.nombreCompleto) ||
  texto(perfil.nombre) ||
  "";

// `comentario` es el item ya normalizado; `perfil` es lo que devolvio el resolvedor
// de perfiles para su `idUsuario`, si es que llego; `usuarioActual` es la sesion.
//
// El orden de preferencia y su porque:
//   1. El propio usuario -> se usa la sesion. Ya esta en memoria y siempre esta al
//      dia; pedirla otra vez seria una peticion de mas por cada comentario propio.
//   2. El perfil resuelto -> es la unica fuente con nombre real y foto.
//   3. Lo que mando el backend en el comentario -> el arroba. Feo, pero identifica a
//      alguien; es mejor que un hueco mientras el perfil viaja o si falla.
export const resolveAutorComentario = ({
  comentario = {},
  perfil = null,
  usuarioActual = null,
  fotoUsuarioActual = "",
} = {}) => {
  const esPropio =
    Boolean(usuarioActual?.idUsuario) &&
    comentario?.idUsuario === usuarioActual.idUsuario;

  if (esPropio) {
    return {
      nombre: nombreDePerfil(usuarioActual) || texto(comentario.autor) || "",
      foto:
        fotoUsuarioActual ||
        getProfileImageFromUser(usuarioActual) ||
        DEFAULT_PROFILE_IMAGE,
    };
  }

  const nombrePerfil = perfil ? nombreDePerfil(perfil) : "";

  return {
    nombre: nombrePerfil || texto(comentario.autor) || "",
    foto:
      (perfil && getProfileImageFromUser(perfil)) ||
      getProfileImageFromUser(comentario) ||
      DEFAULT_PROFILE_IMAGE,
  };
};

// Ids de autor que hace falta ir a buscar: los que no son del usuario en sesion y
// todavia no estan resueltos. Se devuelven sin repetir, porque un hilo suele tener
// varios comentarios de la misma persona y seria una peticion por comentario.
export const idsDeAutoresPendientes = ({
  comentarios = [],
  perfiles = {},
  idUsuarioActual = null,
} = {}) => [
  ...new Set(
    comentarios
      .map((c) => c?.idUsuario)
      .filter(
        (id) =>
          Boolean(id) &&
          id !== idUsuarioActual &&
          !Object.prototype.hasOwnProperty.call(perfiles, id)
      )
  ),
];
